<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'
  export default {
    name: 'VatButtons',
    components: {ModalReveal},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>V${this.item.id} vat?</strong>`, () => {
          KeplerBackofficeSdk.vats.select(this.item.id).remove(() => {
            MaggieHelper.notification('', 'Vat deleted')
            this.$emit('itemUpdated')
            this.$store.dispatch('loadVat')

          })
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VatButtons.vue?22dc8c4a